import { render, staticRenderFns } from "./NewPagina.vue?vue&type=template&id=72ae36a6&scoped=true"
import script from "./NewPagina.vue?vue&type=script&lang=ts"
export * from "./NewPagina.vue?vue&type=script&lang=ts"
import style0 from "./NewPagina.vue?vue&type=style&index=0&id=72ae36a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae36a6",
  null
  
)

export default component.exports